import {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import SecurityService from "../services/Security";
import TokenService from "../services/Token";
import { onResponseError } from "./responseErrorInterceptor";
import { InsightService } from "@pepper/insights-react";
import { convertLeadToken } from "../utils/convertLeadToken";
import { loadGTMSession } from "../utils/gtmConfig";


const onRequest = async (config: InternalAxiosRequestConfig) => {
  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  let token;
  let authenticationToken;
  if (urlParams.get("lead_token") && !TokenService.getToken()) {
    authenticationToken = urlParams.get("lead_token")?.replace(/ /g, "+");
    authenticationToken && TokenService.setLeadToken(authenticationToken);
    const accessToken = await handleAuthenticationToken(authenticationToken);
    if (accessToken) {
      TokenService.setToken(accessToken);
      token = accessToken;
    }
    loadGTMSession();
  } else {
    token = TokenService.getToken();
  }
  if (
    !urlParams.get("show_header") ||
    urlParams.get("show_header") === "true"
  ) {
    sessionStorage.setItem("pepper-landing-header", "true");
  }
  if(urlParams.get("viewMode")) {
    const value = urlParams.get("viewMode")!.toString().toUpperCase();
    sessionStorage.setItem("pepper-view-mode", value);
  }
  const accessToken = token;
  if (config.headers && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  }
  return config;
};

const handleAuthenticationToken = async (
  authToken: any
): Promise<string | undefined> => {
  const decodedToken = convertLeadToken(authToken);
  let result = "";
  try {
    await SecurityService.authenticate(decodedToken).then((response) => {
      result = response.access_token;
      return result;
    });
  } catch {
    return result;
  }
  return result;
};
const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  InsightService.logEvent("Request", [
    {
      request: {
        requestURL: response.request?.responseURL,
        config: response.config,
      },
    },
    { response: response.data },
  ]);
  return response.data.data;
};

export function setupInterceptorsTo(
  axiosInstance: AxiosInstance
): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
